import { getDoChatMessages } from "@do/do-chat-messages";
import type { DochatAuthPublicReason } from "@do/shared-types";

// The texts of the sign-in: the chat's login screen and the popup pages, in the chat's locale.
export type AuthTexts = {
  title: string;
  signInWithCompany: (company: string) => string;
  signInWithDialOnce: string;
  openInNewTab: string;
  popupBlocked: string;
  waiting: string;
  differentUserHint: string;
  signOutAndUseAnother: string;
  reference: (reference: string) => string;
  signingIn: string;
  signedIn: string;
  signedOut: string;
  /**
   * The message of a public reason, and only of one: whatever else a URL or an answer carries
   * shows as `sign_in_failed`. No provider text, email or alias ever reaches the screen.
   */
  reason: (reason: unknown) => string;
};

/** The sign-in texts of `@do/do-chat-messages`, in the locale (French when unsupported). */
export function getAuthTexts(locale: string): AuthTexts {
  const auth = getDoChatMessages(locale || "fr")["do-chat-common"].auth;
  const reasons: Record<DochatAuthPublicReason, string> = auth.reasons;
  return {
    ...auth,
    signInWithCompany: (company) => auth.signInWithCompany.replace("{company}", company),
    reference: (reference) => auth.reference.replace("{reference}", reference),
    reason: (reason) =>
      Object.prototype.hasOwnProperty.call(reasons, String(reason))
        ? reasons[reason as DochatAuthPublicReason]
        : reasons.sign_in_failed,
  };
}
